module.exports = "<div class=\"popup\">\n    <div class=\"content\">\n        <p>{{sentence}}</p>\n\n        <div class=\"important\" *ngIf=\"popupService.getData('lastPublicPicture')\">\n            {{ 'chat.warning-public-pictures' | translate }}\n        </div>\n    </div>\n    <div class=\"footer\">\n        <button (click)=\"accept()\">{{'common.yes' | translate}}</button>\n        <button (click)=\"cancel()\">{{'common.cancel' | translate}}</button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/popup/types/deletePicture/popup-delete-picture.component.html
// module id = 480
// module chunks = 0